import React, { useContext, useState, Fragment, useRef } from 'react'
import { TextField } from '@mui/material'

import useLog from '../../hooks/useLog.js'
import useTxSender from '../../hooks/useTxSender.js'
import { forceFloat } from "../../helpers/helpers.js"
import { UserContext } from "../../Contexts/UserContext/UserContext.js"
import { FormattedNumber } from "../../components/FormattedNumber"
import { Row } from "../../components/Row"
import { Spaces } from "../../components/Spaces"
import { TextDisplay } from "../../components/TextDisplay/TextDisplay"
import SoldeToken from '../../components/SoldeToken.js'
import SuccessTxSender from '../../components/SuccessTxSender.js'
import { default_func_jsx_fail } from '../../helpers/helpers.js'
import InputTokenAddress from '../../components/InputTokenAddress.js'
import { ButtonPrimary } from '../../components/Buttons.js'



// tests for debugging the management of errors
const test_txfailtoload = false
const test_broadcastfails = false


/**
 *  props: no specific props
*/
export default function Slide_Send_Tokens(props) {
	const userContext = useContext(UserContext)
	const coinProps = userContext.get_selected_coin_props()
	// examples: coinProps.tokenid ticker .name .logo .color
	const function_id = "Slide_Send_Tokens(" + coinProps.name + "): "
	const log = useLog(function_id)

	log("coinProps.tokenid=", coinProps.tokenid)

	const tokenActionID = coinProps.tokenid + "_send" // or send_delphe ?

	const mess_default = "" // "Un récapitulatif des "+coinProps.name+" à envoyer va s'afficher ici"

	// state & refs
	const [send_tokenAddress, set_send_tokenAddress] = useState("")
	const [send_nbtokens, set_send_nbtokens] = useState("")

	const ref_messageEndRef = useRef(null) // for autoscroll

	const array_bool_user_inputs = [
		Boolean(send_nbtokens && send_nbtokens > 0),
		Boolean(send_tokenAddress && send_tokenAddress.length > 0),
	]

	const token_balance = userContext.tokens_balance[coinProps.tokenid]
	const bool_context_has_loaded = (token_balance != null)


	// --- FUNCTIONS ---

	async function func_empty_fields() {
		set_send_tokenAddress("")
		set_send_nbtokens("")
	}

	var jsx_loading = null //<LoaderWithMess mess={mess_default} />
	var jsx_recap = null // add each field one by one
	// add tokens nb
	// if (send_nbtokens && send_nbtokens > 0) {
	// 	jsx_recap = <Fragment>
	// 		{jsx_recap?
	// 			<Fragment>{jsx_recap} <br/><br/></Fragment>
	// 		:null}
	// 		envoi de {send_nbtokens} {coinProps.coinProps.name}<br/>
	// 	</Fragment>
	// }

	const step_messages = {
		syncing_contract: "Syncing token contract...",
		finding_utxos: "Finding matching token UTXOs in wallet...",
		broadcasting: "Broadcasting transaction to the network...",
		checking_success: "Checking broadcast success...",
		done: "Transaction sent successfully!",
	}

	const jsx_sending = (txstate) => {
		const step_mess = (txstate && txstate.step && step_messages[txstate.step]) || "Veuillez patienter..."
		return <Fragment>
			Envoi en cours de &nbsp;
			<FormattedNumber value={send_nbtokens} decimals="2" separator=" " />
			&nbsp; {coinProps.name} à l'adresse {send_tokenAddress} <br /><br />

			{step_mess} <i className="reloadIcon fas fa-sync fa-spin" />
		</Fragment>
	}

	const func_jsx_success = (txstate) => {
		return (
			<SuccessTxSender txstate={txstate}>
				Envoi avec succès de {txstate.nbtokens} {coinProps.name} à l'adresse {txstate.sendto_address}
			</SuccessTxSender>
		)
	}

	// --- HOOK useTxSender ---

	var [
		bool_broadcast_lock,
		func_resetMess,
		dict_sendbutton_style,
		jsx_mess,
	]
		= useTxSender(
			tokenActionID,
			array_bool_user_inputs,
			bool_context_has_loaded,
			ref_messageEndRef,
			mess_default,
			jsx_loading,
			jsx_recap,
			jsx_sending,
			func_jsx_success,
			default_func_jsx_fail,
			func_empty_fields,
		)


	// --- FUNCTIONS ---

	function handleChange_ValidAddress(new_token_address) {
		const function_id_2 = function_id + "handleChange_address(): "
		const log = (...args) => { console.log(function_id_2, ...args) }

		if (bool_broadcast_lock) return // don't allow edit during sending
		func_resetMess()

		log("new valid address to send to:", new_token_address)
		set_send_tokenAddress(new_token_address)
	}

	function handleChange_tokenBalance(event) {
		const function_id_2 = function_id + "handleChange_tokenBalance(): "
		const log = (...args) => { console.log(function_id_2, ...args) }

		if (bool_broadcast_lock) return // don't allow edit during sending
		func_resetMess()

		var val = event.target.value
		// beware we want to allow '0.'
		if (val !== '0.') {
			val = forceFloat(val)
			if (Number.isNaN(val)) val = ""
		}
		if (val < 0) val = -1 * val
		log("new token_balance = ", val)

		set_send_nbtokens(val)
	}

	function handleClick(event) {
		event.preventDefault() // prevent redirection
		if (!bool_broadcast_lock) {
			// async but we don't want to await here !
			userContext.sendtx_Token(send_tokenAddress, send_nbtokens,
				test_txfailtoload, test_broadcastfails)
		}
	}

	if (parseFloat(send_nbtokens) === 0) {
		dict_sendbutton_style = {
			backgroundColor: "gray",
			pointerEvents: "none",
		}
	}

	log("\n send_tokenAddress =", send_tokenAddress,
		"\n send_nbtokens =", send_nbtokens, " parseFloat:", parseFloat(send_nbtokens),
		"\n bool_broadcast_lock=", bool_broadcast_lock,)

	const header_jsx = <>
		<h1><i className="fas fa-paper-plane" /><Spaces count="3" />
			Send {coinProps.name}
		</h1>
		<br />
		<center>
			<SoldeToken />
		</center>
		<br /><br />
	</>

	return (
		<div>
			{header_jsx}

			<InputTokenAddress
				tokenName={coinProps.name}
				tokenID={coinProps.tokenid}
				variant="token"
				value={send_tokenAddress}
				onValidChange={handleChange_ValidAddress}
				title={"Send to " + coinProps.name + " address"}
			/>

			<Row>
				<TextField fullWidth
					id="outlined-basic" variant="outlined"
					label={<span>Amount of {coinProps.name} to send</span>}
					value={send_nbtokens ? send_nbtokens : ""}
					onChange={handleChange_tokenBalance}
					placeholder="ex: 25.10"
				// helperText={Constants.SEND_TOKENS_POPOVER}
				/>
			</Row><br />

			<center>
				<div ref={ref_messageEndRef}>
					{jsx_mess ?
						<Row>
							<TextDisplay>
								{jsx_mess}
							</TextDisplay>
						</Row>
						: null}
				</div>
			</center>

			{/* <Row>
				<button onClick={handleClick} id='tokens_send' className="submitbutton"
					style={dict_sendbutton_style} >
					Envoyer {send_nbtokens} {coinProps.name} &nbsp; <i className="fas fa-paper-plane" />
				</button>
			</Row> */}

			<ButtonPrimary onClick={handleClick}
				style={{
					borderRadius: "100px", padding: "10px 20px", width: "100%",
					fontSize: "1.2em", ...dict_sendbutton_style
				}}>
				Send {send_nbtokens} {coinProps.name} &nbsp; <i className="fas fa-paper-plane" />
			</ButtonPrimary>

		</div>
	)
}
